var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"offer-goals-tab",class:{
        '--create-goal': _setup.isCreateModeGoals
    }},[(_setup.isCreateModeGoals)?_c(_setup.OfferGoalsCreate,{attrs:{"offer":_vm.offer},on:{"disable-create-mode":_setup.disableCreateMode}}):_c(_setup.BaseEditableCard,{attrs:{"title":"","is-loading":_setup.isLoading,"is-show-edit-buttons":false}},[_c(_setup.OfferGoals,{ref:"goalsComp",attrs:{"offer":_vm.offer,"is-edit":_setup.isEditModeGoals}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }